class Results {
    private simIndex: string;
    private showCassol: boolean;
    private heatmap: string;
    private trajectory: string;
    private simulationTime: string;
    private averageDistanceWalked: string;
    private averageVelocity: string;
    private averageDensity: string;
    private averageTime: string;
    private newMetric: string;
    private cassolMetric: string;

    constructor(
        simIndex: string,
        showCassol: boolean,
        heatmap: string, 
        trajectory: string, 
        simulationTime: string,
        averageDistanceWalked: string,
        averageVelocity: string,
        averageDensity: string,
        averageTime: string,
        newMetric: string,
        cassolMetric: string,
        ) {
        this.simIndex = simIndex;
        this.showCassol = showCassol;
        this.heatmap = heatmap;
        this.trajectory = trajectory;
        this.simulationTime = simulationTime;
        this.averageDistanceWalked = averageDistanceWalked;
        this.averageVelocity = averageVelocity;
        this.averageDensity = averageDensity;
        this.averageTime = averageTime;
        this.newMetric = newMetric
        this.cassolMetric = cassolMetric;
    }

    
    public getSimIndex() : string {
        return this.simIndex; 
    }

    public canShowCassol(): boolean {
        return this.showCassol;
    }
    
    public getHeatmap() : string {
        return this.heatmap;
    }

    public getTrajectory() : string {
        return this.trajectory;
    }

    public getSimulationTime() : string {
        return parseFloat(this.simulationTime).toFixed(2).toString();
    }

    public getAverageDistanceWalked() : string {
        return parseFloat(this.averageDistanceWalked).toFixed(2).toString();
    }

    public getAverageVelocity() : string {
        return parseFloat(this.averageVelocity).toFixed(2).toString();
    }

    public getAverageDensity() : string {
        return parseFloat(this.averageDensity).toFixed(2).toString();
    }

    public getAverageTime() : string {
        return parseFloat(this.averageTime).toFixed(2).toString();
    }

    public getNewMetric() : string {
        return parseFloat(this.newMetric).toFixed(4).toString();
    }
    
    public getCassol() : string {
        return parseFloat(this.cassolMetric).toFixed(4).toString();
    }
    


}

export default Results;